/**
 * JSON:API body for `POST …/conversations` and
 * `PUT …/conversations/:id/draft_members` (`messaging-conversation` adapter
 * `createConversation` and `updateDraftMembers`).
 * Selected contacts live on `data.attributes.contacts`; a couple is one element
 * with partners nested on `attributes.couple`.
 */
export function buildDraftMembersContactsPayload(contacts) {
  return {
    data: {
      type: 'conversations',
      attributes: {
        contacts: contacts.map(contactToSelectedEntry),
      },
    },
  };
}

function couplePartners(contact) {
  if (contact.couple?.length) {
    return [...contact.couple];
  }
  return [];
}

function contactToSelectedEntry(contact) {
  const attributes = {
    external_id: contact.externalId ?? contact.id,
    external_scope: contact.externalScope,
    organization_id: contact.organizationId,
    name: contact.name,
  };

  const partners = couplePartners(contact);
  if (partners.length > 1) {
    attributes.couple = partners.map(contactToSelectedEntry);
  }

  return { type: 'contacts', attributes };
}
